import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import { CONTACT_EMAIL } from '../constants/contact';

export default function CookiePolicy() {
  return (
    <LegalPageLayout
      title="Política de cookies"
      lastUpdated={new Date().toLocaleDateString('pt-PT', { year: 'numeric', month: 'long', day: 'numeric' })}
    >
      <h2>1. O que são cookies?</h2>
      <p>
        Os cookies são pequenos ficheiros de texto armazenados no seu dispositivo quando visita um sítio web. Tecnologias
        semelhantes incluem armazenamento local e pixels. Esta política explica como a NeoDrive utiliza cookies e como
        os pode controlar.
      </p>

      <h2>2. Como utilizamos cookies</h2>
      <p>Utilizamos cookies e tecnologias relacionadas para finalidades como:</p>
      <ul>
        <li>
          <strong>Estritamente necessários:</strong> necessários para segurança, balanceamento de carga, sessões de
          autenticação e funcionalidade essencial;
        </li>
        <li>
          <strong>Preferências:</strong> memorizar escolhas como idioma ou região quando aplicável;
        </li>
        <li>
          <strong>Análises:</strong> compreender como os visitantes utilizam o nosso sítio para melhorar desempenho e
          conteúdo (frequentemente de forma agregada);
        </li>
        <li>
          <strong>Marketing:</strong> apenas quando ativado e permitido, para medir campanhas ou apresentar conteúdo
          relevante.
        </li>
      </ul>

      <h2>3. Cookies de terceiros</h2>
      <p>
        Alguns cookies podem ser definidos por fornecedores de análises ou conteúdo incorporado que utilizamos. Esses
        fornecedores tratam dados segundo as suas próprias políticas. Recomendamos rever a documentação deles quando
        relevante.
      </p>

      <h2>4. Conservação</h2>
      <p>
        Os cookies de sessão expiram quando fecha o navegador. Os cookies persistentes permanecem por um período
        definido ou até os apagar. As durações exatas podem variar conforme o tipo de cookie e o fornecedor.
      </p>

      <h2>5. As suas escolhas</h2>
      <p>
        Pode controlar cookies através das definições do navegador (bloquear, apagar ou alertar). Bloquear cookies
        estritamente necessários pode afetar o funcionamento do sítio ou da aplicação. Quando oferecermos um banner de
        cookies ou centro de preferências, pode ajustar categorias não essenciais aí.
      </p>

      <h2>6. Do Not Track</h2>
      <p>
        Não existe um padrão da indústria consistente para sinais DNT. Tratamos escolhas de privacidade através dos
        controlos disponíveis e da lei aplicável.
      </p>

      <h2>7. Atualizações</h2>
      <p>
        Podemos atualizar esta Política de Cookies para refletir alterações tecnológicas ou legais. A data de
        &quot;Última atualização&quot; será revista quando o fizermos.
      </p>

      <h2>8. Contacto</h2>
      <p>
        Questões:{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalPageLayout>
  );
}
